import React, { useEffect, useMemo, useState } from "react";
import { Backdrop, Fade, Paper, Typography, Divider, CircularProgress } from "@material-ui/core";
import BranchSelect from "../../Components/BranchSelect";
import DateRangeBar from "../../Components/DateRangeBar";
import HeatmapTableColor from "../../Components/HeatmapTableColor";
import { Api } from "../../api/client";

function todayISO(){ const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`; }
function daysAgoISO(n){ const d=new Date(); d.setDate(d.getDate()-n); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`; }

export default function HorarioPico(){

  const [branches,setBranches]=useState([]);
  const [branchId,setBranchId]=useState("");
  const [range,setRange]=useState({from:daysAgoISO(7),to:todayISO()});
  const [loading,setLoading]=useState(false);
  const [heatmap,setHeatmap]=useState(null);

  const params=useMemo(()=>({from:range.from,to:range.to,branch:branchId}),[range,branchId]);

  useEffect(()=>{
    Api.branches().then(res=>setBranches(res.data))
      .catch(()=>setBranches([{id:"",nombre:"Todas"}]));
  },[]);

  useEffect(()=>{
    async function load(){
      setLoading(true);
      try{
        const r=await Api.heatmap(params);
        setHeatmap(r);
      }catch(e){ console.error(e); setHeatmap(null); }
      setLoading(false);
    }
    load();
  },[params]);

  return (
    <>
      <Backdrop open={loading} style={{zIndex:2000,color:"#fff"}}>
        <Fade in={loading}>
          <Paper style={{padding:30,borderRadius:14}}>
            <CircularProgress/>
            <Typography style={{marginTop:12,fontWeight:900}}>Analizando horas pico...</Typography>
          </Paper>
        </Fade>
      </Backdrop>

      <Paper style={{padding:18,borderRadius:14}}>
        <Typography variant="h6" style={{fontWeight:900}}>Horario punta (Heatmap)</Typography>
        <Divider style={{margin:"12px 0"}}/>

        {heatmap ? (
          <HeatmapTableColor
            days={heatmap.days}
            hours={heatmap.hours}
            matrix={heatmap.matrix}
          />
        ) : (
          <Typography variant="body2">Sin datos.</Typography>
        )}
      </Paper>
    </>
  );
}